import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { selectLoggedIn } from "../store/slices/auth/slice";

const OrganizationUserLayout = () => {
  const loggedIn = useSelector(selectLoggedIn);

  let publicPath = "/log-in";

  return loggedIn ? (
    <>
      <Outlet />
    </>
  ) : (
    <Navigate to={publicPath} state={{}} replace />
  );
};

export default OrganizationUserLayout;
